import { useState } from 'react';
import { useSession } from './useSession.js';
import { getTimeZone } from '@/lib/time-zones.js';

/**
 * Retrieves the current acting user's preferred time zone. If they do not
 * have one set, use the browser's guess.
 */
export function useTimeZone() {
  const [timeZone, setTimezone] = useState<string>(getTimeZone(useSession().actingUser.timeZone));

  return {
    timeZone,
    setTimezone,
  };
}
